var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16602 0.666687C12.3082 0.666687 15.666 4.02455 15.666 8.16669C15.666 9.93734 15.0524 11.5647 14.0263 12.8477L17.0886 15.9108C17.414 16.2362 17.414 16.7638 17.0886 17.0893C16.7882 17.3897 16.3155 17.4128 15.9886 17.1586L15.9101 17.0893L12.847 14.0269C11.564 15.0531 9.93667 15.6667 8.16602 15.6667C4.02388 15.6667 0.666016 12.3088 0.666016 8.16669C0.666016 4.02455 4.02388 0.666687 8.16602 0.666687ZM8.16602 2.33335C4.94435 2.33335 2.33268 4.94503 2.33268 8.16669C2.33268 11.3883 4.94435 14 8.16602 14C11.3877 14 13.9993 11.3883 13.9993 8.16669C13.9993 4.94503 11.3877 2.33335 8.16602 2.33335Z",
    fill: "#999DA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputSearch);
export default __webpack_public_path__ + "static/media/inputSearch.67a956e8.svg";
export { ForwardRef as ReactComponent };